import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import { PaginatedApiResponse, Ticket } from 'types';

type TicketsQueryParams = {
  currentPage: number;
  recordsPerPage: number;
  status: '0' | '1' | null;
};

export const getJobTickets = async ({
  queryKey,
}: QueryFunctionContext<['get-tickets', 'job', jobId: string | undefined, TicketsQueryParams]>) => {
  const jobId = queryKey[2];
  const { currentPage, recordsPerPage, status } = queryKey[3];

  const job = jobId ? `&job_id=${jobId}` : '';
  const statusFilter = status ? `&status=${status}` : '';

  const data: PaginatedApiResponse<Ticket[]> = await baseQuery(
    `job-tickets?page=${currentPage}&per_page=${recordsPerPage}${job}${statusFilter}`,
  );

  return data;
};
